import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { BrandMark } from '@/components/brand/BrandMark';
import { Button } from '@/components/ui/Button';

export function LoginPage() {
  const navigate = useNavigate();
  const { loginWithCognito } = useAuth();

  const handleSignIn = () => {
    loginWithCognito();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <BrandMark size={48} className="mx-auto mb-4" />
          <h1 className="text-3xl font-semibold tracking-tight">Welcome Back</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Sign in to your My Budget account
          </p>
        </div>

        <Button
          onClick={handleSignIn}
          className="w-full h-12 text-base"
          size="lg"
        >
          Continue with Google
        </Button>

        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-background px-2 text-muted-foreground">
              Go back
            </span>
          </div>
        </div>

        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="w-full"
        >
          Return to Home
        </Button>

        <p className="text-xs text-muted-foreground text-center mt-6">
          Having trouble signing in?{' '}
          <a href="mailto:support@balance.local" className="text-primary hover:underline">
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
}
